var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Flag = function Flag(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20 5a1 1 0 0 0-1.7-.715 4 4 0 0 1-5.6 0 6 6 0 0 0-8.4 0A.997.997 0 0 0 4 5v16a1 1 0 1 0 2 0v-6.552a4 4 0 0 1 5.3.266 6 6 0 0 0 8.4 0c.2-.196.3-.455.3-.715M6 5.45v6.667a5.998 5.998 0 0 1 6.7 1.17 4 4 0 0 0 5.3.266V6.884a6 6 0 0 1-6.7-1.17A4 4 0 0 0 6 5.448Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Flag;